import React, { useEffect, useState } from "react";
import SharedDiv from "../../../../Components/SharedDiv/SharedDiv";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import {
  GetConflictOfInterestListByAppGuid,
  UpdateConflictOfInterestList,
} from "../../../../Redux/Reducers/Submitter/ConflictsOfInterestAndResearchEthics";
import axios from "axios";
import loadConfig from "../../../../Services/Api/ApiServices";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
import { setRefreshTable } from "../../../../Redux/Reducers/Shared/VariousVariables";
import { UpdateConflictOfInterest } from "../../../../Services/Conflict/UpdateConflictOfInterest";

function ConflictOfInterest(props) {
  const dispatch = useDispatch();
  const [dataJsonObject, SetDataJsonObject] = useState();
  // Function to load configuration data
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
  };

  const jsonData = useSelector((state) => state.FetchDataJson.JsonData);

  useEffect(() => {
    dataJson();
  }, []);
  const state = useSelector((state) => {
    return {
      ConflictOfInterest: state.ConflictOfInterest.ConflictOfInterest,
      ConflictOfInterestUpdate:
        state.ConflictOfInterest.ConflictOfInterestUpdate,
      loadingConflictOfInterest:
        state.ConflictOfInterest.loadingConflictOfInterest,

      ApplicationInformation:
        state.ApplicationInformationReducer.ApplicationInformation,

      refreshTableStatus: state.refreshTableStatus.refreshTable,
    };
  });
  const ActiveRound = useSelector((state) => state.RoundReducers.ActiveRound);
  const ApplicationInformation = useSelector(
    (state) => state.ApplicationInformationReducers.ApplicationInformation
  );
  console.log(state?.ConflictOfInterest, "ConflictOfInterest");

  const [ConflictOfInterestList, setConflictOfInterestList] = useState(
    state?.ConflictOfInterest
  );

  const [data, setData] = useState([]);
  const [loding, setLoding] = useState(false);
  const [refreash, setrefreash] = useState(0);
  useEffect(() => {
    dispatch(
      GetConflictOfInterestListByAppGuid(
        localStorage.getItem("ApplicationInformationId") ||
          props.applicationGuid
      )
    );
  }, [state.ApplicationInformation, state.refreshTableStatus]);

  useEffect(() => {
    setConflictOfInterestList(state?.ConflictOfInterest);
  }, [state?.ConflictOfInterest]);

  console.log(ConflictOfInterestList, "sss");
  let a = ConflictOfInterestList;

  const getData = () => {
    if (jsonData.domainUrl)
      axios
        .post(
          `${jsonData.domainUrl}/api/ConflictsOfInterestAndResearchEthics/GetConflictsOfInterestAndResearchEthicsListByAppGuid`,
          {
            applicationInformationId:
              localStorage.getItem("ApplicationInformationId") ||
              props.applicationGuid,
          }
        )
        .then((result) => {
          const data = result.data.result;
          console.log(result.data.result, " resultresult");

          const yesNoList = {};
          data.forEach((marks) => {
            if (!yesNoList[marks.questionsGroupingName]) {
              yesNoList[marks.questionsGroupingName] = {
                GroupingName: "",
                row: "",
                value: [],
              };
            }
            yesNoList[marks.questionsGroupingName].GroupingName =
              marks.questionsGroupingName;
            yesNoList[marks.questionsGroupingName].row = marks.rowSorting;
            yesNoList[marks.questionsGroupingName].value.push(marks);
          });
          console.log(yesNoList, "kjkjkjkjj");

          setData(yesNoList);
          setLoding(true);
        });
  };

  useEffect(() => {
    getData();
  }, [state.refreshTableStatus, refreash]);

  const UpdateData = async (obj) => {
    console.log(obj, "objobj", data);

    // dispatch(
    //   UpdateConflictOfInterestList({
    //     updateListSU_NT_COIARE_ConflictsOfInterestAndResearchEthics: obj,
    //   })
    // );
    const updated = await UpdateConflictOfInterest({
      updateListSU_NT_COIARE_ConflictsOfInterestAndResearchEthics: obj,
    });
    console.log(updated, "ubdated565");
    if (updated?.data.success == true) {
      setrefreash(refreash + 1);
    }
  };

  useEffect(() => {
    dispatch(setRefreshTable());
  }, [state.ConflictOfInterestUpdate]);

  const shouldDisableFields = !(
    ActiveRound == ApplicationInformation?.aI_RoundYearId &&
    ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.canEdit &&
    window.location.href.includes("manager") == false
  );
  console.log(data, "datafffffff");

  return (
    <>
      {data && data ? (
        <>
          {Object.keys(data).map((ele, index) => {
            console.log(data[ele].value, "element");

            return (
              <>
                <SharedDiv
                  showTitle={true}
                  titleName={ele}
                  child={[
                    <div className="table-responsive">
                      <div className="table-container">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>السؤال</th>
                              <th>نعم/لا</th>
                              <th>التوضيح</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data[ele]?.value.map((item, index) => (
                              <tr key={index}>
                                <td>{item.questionsName}</td>
                                <td>
                                  <AllDropDownsAHSF
                                    fieldsName="yesNoTableDropDown"
                                    yesNo={true}
                                    disabled={shouldDisableFields}
                                    hidelable={true}
                                    show={true}
                                    dropdownType="normal"
                                    arrayOoptionList={[
                                      { text: "نعم", value: true },
                                      { text: "لا", value: false },
                                    ]}
                                    value={item.yesNo}
                                    KeyText={"text"}
                                    KeyValue={"value"}
                                    onChange={(e) => {
                                      item.yesNo = JSON.parse(e.target.value);
                                      UpdateData(data[ele]?.value);
                                    }}
                                  />
                                </td>
                                <td>
                                  <textarea
                                    className="textarea-field"
                                    disabled={shouldDisableFields}
                                    placeholder="اكتب التوضيح هنا..."
                                    defaultValue={item.explanation}
                                      // value={item.explanation || ""}
                                    onChange={(e) => {
                                      item.explanation = e.target.value;
                                      UpdateData(data[ele]?.value);
                                    }}
                                    onBlur={(e) => {
                                      item.explanation = e.target.value;
                                    }}
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>,
                  ]}
                />
              </>
            );
          })}
        </>
      ) : (
        <></>
      )}
    </>
  );
}

export default ConflictOfInterest;
